import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class CounselService {
  private api = inject(ApiService);

  getOne(id: number) { return this.api.get(`/counsel/${id}`); }
  getTrainingProgramList() { return this.api.get('/training'); }
  getTrainingMachineList() { return this.api.get('/training_machine'); }
  upsert(json: any) { return this.api.post('/counsel', json); }
  upsertPersonal(json: any) { return this.api.post('/personal', json); }
  updatePictureRotate(json: any) { return this.api.post('/counsel/picture/rotate', json); }
  removePicture(json: any) { return this.api.post('/counsel/picture/remove', json); }

  async uploadPicture(id: number, pictureId: number, fileData: FormData): Promise<any> {
    return this.api.post(`/counsel/${id}/picture/${pictureId}`, fileData);
  }
}
